import {CustomersAPI} from "../api/CustomersAPI"
import {AppStore} from "../desktop"
import {actionCustomerFetchAllCompleted, actionCustomerFetchCompleted} from "../store/customers/actions"
import {BaseService} from "./BaseService"
import {Customer} from "../models/Customer"
import {CustomersActionTypes} from "../store/customers"
import {ContactsAPI} from "../api/ContactsAPI"
import {Contact} from "../models/Contact"
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import ContactsService from "./ContactsService";
import {FinanceType} from "../models/CustomerFinances";
import {Formater} from "../core/Formater";
import {Utility} from "../core/Utility";
import {Invoice} from "../models/Invoice";
import {Payment} from "../models/Payment";
import moment = require("moment");
import {type} from "os";
import {actionToastrInfo} from "../store/global";

export default class CustomersService extends BaseService {

	static getAll() {

        let customersAPI: CustomersAPI = new CustomersAPI()

		customersAPI.getAll().then(CustomersService.processResponse)
		.then((result) => actionCustomerFetchAllCompleted(CustomersService.fromAPICustomerList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(customer: Customer) {

		let customersAPI: CustomersAPI = new CustomersAPI()
		let contactsAPI: ContactsAPI = new ContactsAPI(customer.id)

		let contactsResults: Contact[] = []
		let customerResult: Customer

		Promise.all([

			contactsAPI.getAll().then(CustomersService.processResponse)
			.then((result) => {
				contactsResults = CustomersService.responseToContacts(result)
			}).catch(error => ErrorService.handleError(error)),

			customersAPI.get(customer).then(CustomersService.processResponse).then(result => {
				customerResult = CustomersService.fromAPICustomer(result)
			}).catch(error => ErrorService.handleError(error))

		]).then((value: any) => {

			customerResult.contacts = contactsResults
			actionCustomerFetchCompleted(customerResult)

		})
    }

    static save(customer: Customer) {

        let customersAPI: CustomersAPI = new CustomersAPI()

		if (customer.id) {
			customersAPI.put(CustomersService.customerToRequest(customer)).then(CustomersService.processResponse).then(
				(data) => {
					actionSetTabStateItem(customer)
					actionSetTabItem(customer)
					AppStore.dispatch({
						type: CustomersActionTypes.SAVE_COMPLETED, payload: CustomersService.fromAPICustomer(customer)
					})
					actionToastrInfo("Info", "Klijent je uspešno snimljen")
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			customersAPI.post(CustomersService.customerToRequest(customer)).then(CustomersService.processResponse).then(
				(data) => {
					actionSetTabStateItem(CustomersService.fromAPICustomer(data))
					actionSetTabItem(CustomersService.fromAPICustomer(data))
					AppStore.dispatch({
						type: CustomersActionTypes.SAVE_COMPLETED, payload: CustomersService.fromAPICustomer(data)
					})
					actionToastrInfo("Info", "Klijent je uspešno snimljen")
				}
			).catch(error => ErrorService.handleError(error))

		}
	}

	static delete(customer: Customer) {

        let customersAPI: CustomersAPI = new CustomersAPI()

		customersAPI.delete(CustomersService.customerToRequest(customer)).then(CustomersService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: CustomersActionTypes.DELETE_COMPLETED, payload: customer
				})
				actionDeleteTabForItemId(customer.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteCustomers(customers: Customer[]) {

		let customersAPI: CustomersAPI = new CustomersAPI()
		let count = 0
		customers.forEach(customer => {

			customersAPI.delete(CustomersService.customerToRequest(customer)).then(CustomersService.processResponse).then(
				(data) => {
					count++
					actionDeleteTabForItemId(customer.id)
					if(count === customers.length)
						AppStore.dispatch({
							type: CustomersActionTypes.DELETE_MULTIPLE_COMPLETED, payload: customers
						})
				}
			).catch(error => ErrorService.handleError(error))
		})

	}

    static fromAPICustomerList(apiCustomerList: any): Customer[] {
        const localCustomerList = apiCustomerList.map((apiCustomer: any) => CustomersService.fromAPICustomer(apiCustomer))
        //console.info('[fromAPICustomerList] converted customers: ', localCustomerList)
        return localCustomerList
    }

    static fromAPICustomer(apiCustomer: any): Customer {
		let customer = new Customer()

		customer.id = apiCustomer.id
		customer.title = apiCustomer.name
		customer.email = apiCustomer.email
		customer.vatId = apiCustomer.vatId
		customer.internalId = apiCustomer.internalId
		customer.companyId = apiCustomer.companyId
		customer.address = apiCustomer.address
		customer.business = apiCustomer.business
		customer.phone = apiCustomer.phone
		customer.representative = apiCustomer.representative
		customer.webAddress = apiCustomer.webAddress
		customer.saldo = apiCustomer.saldo
		customer.contacts = []

		if (apiCustomer.contacts != null) {
			for (let contact of apiCustomer.contacts) {
				let newContact = ContactsService.fromAPIContact(contact)
				customer.contacts.push(newContact)
			}
		}


        return customer
    }

    static customerToRequest (customer: Customer): any {

		let customerRequest: any = {}

		if(customer.id)
			customerRequest.id = customer.id

		customerRequest.name = customer.title
		customerRequest.email = customer.email
		customerRequest.vatId = customer.vatId
		customerRequest.companyId = customer.companyId
		customerRequest.internalId = customer.internalId
		customerRequest.address = customer.address
		customerRequest.business = customer.business
		customerRequest.phone = customer.phone
		customerRequest.representative = customer.representative
		customerRequest.webAddress = customer.webAddress

		return customerRequest
	}

	static responseToCustomers (data: any) {
		return data
	}

	static responseToContacts(data: any){
		return ContactsService.fromAPIList(data)
	}

	static setFinanceItems(items: any, itemType: string) {

		let finances: any = [];

		if(items) {
			items.map((item: any) => {

				let vat = null, invoiceNumber = null, invoiceDeliveryDate = null, invoiceIssueDate = null, invoiceDueDate = null, invoiceContractId = null, invoiceItems = null, paymentDate = null, paymentInvoiceId = null, date = null;

				if(itemType === FinanceType.Invoice) {
					vat = item.vat,
					invoiceNumber = item.number;
					invoiceDeliveryDate = Utility.formatDate(item.deliveryDate);
					invoiceIssueDate = Utility.formatDate(item.issueDate);
					invoiceDueDate = Utility.formatDate(item.dueDate);
					invoiceContractId = item.contractId;
					invoiceItems = item.invoiceItems;
					date = item.issueDate;
				}
				else if(itemType === FinanceType.Payment) {
					paymentDate = Utility.formatDate(item.date);
					paymentInvoiceId = item.invoiceId;
					date = item.date;

					if(item.invoice && item.invoice.number)
						invoiceNumber = item.invoice.number;
				}

				let newItem: any = {};
				newItem.id = item.id;
				newItem.type = itemType,
				newItem.description = item.description,
				newItem.customerId = item.customerId,
				newItem.vat = vat,
				newItem.price = Formater.formatPrice(item.price, 2),
				newItem.invoiceNumber = invoiceNumber,
				newItem.invoiceDeliveryDate = invoiceDeliveryDate,
				newItem.invoiceIssueDate = invoiceIssueDate,
				newItem.invoiceDueDate = invoiceDueDate,
				newItem.invoiceContractId = invoiceContractId,
				newItem.invoiceItems = invoiceItems,
				newItem.paymentDate = paymentDate,
				newItem.paymentInvoiceId = paymentInvoiceId,
				newItem.date = date

				finances.push(newItem);
			});
		}

		return finances;
	}

	static setFinances(invoices: Invoice[], payments: Payment[]) {

		let invoiceFinances: any = this.setFinanceItems(invoices, FinanceType.Invoice)
		let paymentFinances: any = this.setFinanceItems(payments, FinanceType.Payment)

		let finances: any = invoiceFinances.concat(paymentFinances);

		// sort by date desc
		finances.sort((a: any, b: any) => {
			const date1: any = moment.utc(a.date)
			const date2: any = moment.utc(b.date)

			return date2 - date1;
		});

		finances.map((item: any) => item.date = Utility.formatDate(item.date));

		return finances;
	}
}
